


































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';

// DayJS
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);

// Utils
import { truncateString } from '@/utils';

export default Vue.extend({
	name: 'ManOfTheMatches',

	props: {
		mobile: Boolean,
	},

	data: () => ({
		editingDisplayName: false,
		editManOfTheMatch: {
			id: '',
			name: '',
		},
		offset: 0,
		itemsPerPage: 12,
		showFilters: false,
	}),

	computed: {
		...mapGetters(['manOfTheMatches', 'manOfTheMatchSearchFilters', 'countries', 'cities']),

		countryFilterOptions() {
			const countries = [...this.countries];
			const all = { name: 'All', id: null };
			return [all, ...countries];
		},

		cityFilterOptions() {
			return this.cities.filter((c: HasuraCity) => c.country_id === (this as any)._manOfTheMatchSearchFilters.country);
		},

		sortByOptions() {
			return ['Date ASC', 'Date DESC', 'A-Z'];
		},

		_manOfTheMatchSearchFilters: {
			get(): ManOfTheMatchSearchFilters {
				return this.manOfTheMatchSearchFilters;
			},

			set(): void {
				this.$store.commit('setManOfTheMatchSearchFilters', { ...this.manOfTheMatchSearchFilters });
			},
		},

		paginatedManOfTheMatches() {
			return [...(this as any).filteredManOfTheMatches].splice(this.offset, this.itemsPerPage);
		},

		filteredManOfTheMatches() {
			return (
				(this as any).manOfTheMatches
					// Filter by Name
					.filter((manOfTheMatch: any) => {
						const re = new RegExp((this as any)._manOfTheMatchSearchFilters.searchField, 'i');
						const searchMatch = re.test(manOfTheMatch.name);
						// Return true if no country is selected or selected country is same as leagues country
						const isCorrectCountry =
							!(this as any)._manOfTheMatchSearchFilters.country || manOfTheMatch.country.id === (this as any)._manOfTheMatchSearchFilters.country;
						// Return true if no city is selected or selected city is same as leagues city
						const isCorrectCity =
							!(this as any)._manOfTheMatchSearchFilters.cities.length || (this as any)._manOfTheMatchSearchFilters.cities.includes(manOfTheMatch.city.id);
						return searchMatch && isCorrectCountry && isCorrectCity;
					})
					.sort((a: any, b: any) => {
						// Sort by created date descending
						if ((this as any)._manOfTheMatchSearchFilters.sortBy === 'Date DESC') return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();

						// Sort by created date ascending
						if ((this as any)._manOfTheMatchSearchFilters.sortBy === 'Date ASC') return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();

						// Sort by name ascending
						if ((this as any)._manOfTheMatchSearchFilters.sortBy === 'A-Z') {
							const aName = a.name.toLowerCase();
							const bName = b.name.toLowerCase();
							if (aName < bName) return -1;
							if (aName > bName) return 1;
							return 0;
						}

						return 1;
					})
			);
		},
	},

	methods: {
		toggleFilters() {
			this.showFilters = !this.showFilters;
		},

		navigateToManOfTheMatch(manaofthematch: LeagueTableRow) {
			const { id } = manaofthematch;
			this.$router.push({ name: 'man-of-the-match', params: { id } });
		},

		nextPage() {
			this.offset = this.offset + this.itemsPerPage;
		},

		previousPage() {
			this.offset = this.offset - this.itemsPerPage;
		},

		editDisplayName(manOfTheMatch: any) {
			this.editingDisplayName = !this.editingDisplayName;
			this.editManOfTheMatch = {
				id: manOfTheMatch.id,
				name: manOfTheMatch.name,
			};
		},

		async saveDisplayName() {
			await this.$store.dispatch('updateManOfTheMatch', {
				id: this.editManOfTheMatch.id,
				name: this.editManOfTheMatch.name,
			});
			await this.$store.dispatch('getManOfTheMatches');
			this.editingDisplayName = false;
		},

		clearFilters() {
			this.$store.commit('resetManOfTheMatchSearchFilters');
		},
	},

	filters: {
		dateToYear(val: string) {
			return dayjs(val).format('MMM YYYY');
		},

		truncate(str: string) {
			if (!str) return '';
			return truncateString(str, 36);
		},
	},

	async mounted() {
		this.$el.scrollIntoView({ behavior: 'auto' });
		// await this.$store.dispatch('getManOfTheMatches');
		await this.$store.dispatch('getManOfTheMatches');
		this.$store.commit('setBreadcrumb', { root: 'Man Of The Matches', path: 'View All' });
		this.$store.commit('setLoadingState', false);
	},
});
